module.exports = __webpack_public_path__ + "img/canada-map-fr.50236cdf.jpg";